import React from 'react';

export const ListTile = ({ avatar, title, subTitle, trailing, className }) => (
    <div
        className={`list-tile ${className}`}
        style={{ display: 'flex', alignItems: 'center', padding: '10px', gap: '12px' }}
    >
        <div className="list-tile-avatar">{avatar}</div>
        <div className="list-tile-content" style={{ flex: 1 }}>
            <div style={{ color: '#1A1A1A' }}>{title}</div>
            <div className="list-tile-subtitle" style={{ fontSize: '12px', color: '#666' }}>
                {subTitle}
            </div>
        </div>
        <div className="list-tile-trailing">{trailing}</div>
    </div>
);

export const ListTileSkeleton = () => (
    <div style={{ height: '60px', backgroundColor: '#f0f0f0', margin: '5px', borderRadius: '4px' }} />
);

export const SearchBox = ({ onChange, placeholder }) => (
    <input
        type="text"
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
    />
);

export const EmptyPlaceholder = ({ title }) => (
    <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>{title}</div>
);

export const AppIcon = ({ icon, size }) => (
    <i className={`app-icon icon-${size}`} style={{ fontStyle: 'normal' }}>
        {icon}
    </i>
);

export const CustomButton = ({ children, ...props }) => <button {...props}>{children}</button>;

export const Loader = ({ size, color }) => (
    <div className="loader" style={{ width: size, height: size, borderColor: color }}></div>
);

export const clearSearchCache = () => {};
